import { defaultSalesHeaderDto, SalesHeaderDto } from "src/dtos/sales/salesBillDto";
import { formatDate } from "src/utils/string/stringUtil";

/**
 * SAL2030_R01 - 영업 매출 내역 조회 DTO
 */
export interface SAL2030_R01Dto extends SalesHeaderDto {
	rowKey: string;
}

export const createSAL2030_R01RowKey = (compCd?: string, salesDt?: string) => {
	return `${compCd || ''}_${salesDt ? formatDate(salesDt) : ''}`;
};

/**
 * 기본 데이터 (신규 행 추가시 사용)
 */
export const defaultSAL2030_R01Dto: SAL2030_R01Dto = {
	...defaultSalesHeaderDto,
	rowKey: '',
};
